<template>
  <div>
    <div v-if="!this.dialog">
      <span
        class="pointer"
        v-for="(route, index) in routeBack"
        v-bind:key="index"
        v-bind:class="{'backBar': (index - (routeBack.length -1) < 0)}"
        v-on:click="goBack(route, index)">
      <span v-if="routeBack.length > 1">/ </span>{{ route.toUpperCase() }}
      </span>
      <hr>
      <div class="alert alert-warning" v-if="!$online">
        <span>
          <center>
              <v-icon size="25">error</v-icon>
              <b>Bitte stellen Sie eine Internetverbindung her!</b>
              <v-icon size="25">error</v-icon>
          </center>
        </span>
      </div>
      <div class="card" style="z-index: 10">
        <v-progress-linear v-if="loading" color="red" :indeterminate="true"></v-progress-linear>
        <div class="card-header text-xs-inline" id="graphheader">
          <h4 class="card-title">
            {{ title }}
            <v-btn
              flat
              icon
              color="grey"
              id="graphbutton"
              title="Neuen Eintrag erstellen"
              v-on:click="addOrgainvent"
            >
              <v-icon size="50">add_circle</v-icon>
            </v-btn>
            <v-btn
              flat
              icon
              color="grey"
              id="graphbutton"
              title="Liste herunterladen"
              v-on:click="download"
            >
              <v-icon size="50">cloud_download</v-icon>
            </v-btn>
          </h4>
          <p class="card-category tablecard" id="subtitle"></p>
          <v-form>
            <v-container class="auswahl">
              <v-layout align-center wrap>
                <v-flex shrink pa-2>
                  <label for="startdate">Startdatum:&nbsp;</label>
                  <input type="date" id="date" v-model="startdate" />
                  &nbsp;&nbsp;&nbsp;
                  <label for="enddate">Enddatum:&nbsp;</label>
                  <input type="date" id="date" v-model="enddate" />
                </v-flex>
                <v-flex pa-2>
                  <v-btn color="grey" v-on:click="fetchData(startdate, enddate)">anzeigen</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
            <v-divider />
            <v-container class="auswahl">
              <label>Tabelle filtern:</label>
              <v-layout  align-start justify-start row fill-height>
                <v-flex xs12>
                  <v-select
                    v-model="selectedProduct"
                    :items="products"
                    item-text="name"
                    label="Produkte"
                    attach
                    @change="filterLists"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="selectedSBWare"
                    :items="sbWare"
                    item-text="name"
                    item-value="name"
                    label="SB-Ware / Verwendung"
                    return-object
                    attach
                    @change="filterLists"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container class="auswahl">
              <v-checkbox
                v-model="checkbox"
                :label="`Verkaufte Produkte ${checkboxLabel}`"
                @change="changeCheckbox"
              ></v-checkbox>
            </v-container>
          </v-form>
        </div>
      </div>
      <div class="card" v-if="!loading" style="z-index: 9">
        <div class="card--center">
          <label class="labelVerk">Ausgelegte Produkte:</label>
        </div>
        <v-data-table
          :headers="headers"
          :items="filteredLists"
          class="elevation-1"
          :pagination.sync="pagination">
            <template v-slot:items="props">
                
              <td class="text-xs-left" @click="openList(props.item)">{{ props.item.lieferscheindatum | formatDate }}</td>
              <td class="text-xs-left" @click="openList(props.item)">{{ props.item.herkunft.value }}: {{ props.item.herkunft.name }}</td>
              <td class="text-xs-left" @click="openList(props.item)">{{ props.item.product }}</td>
              <!-- <td class="text-xs-left" @click="openList(props.item)">
                {{ props.item.sbware.name }}
                </td> -->
              <td class="text-xs-left" @click="openList(props.item)">
                <span v-for="(kategorie, index) of props.item.sbware" :key="kategorie.value">
                  {{ kategorie.name }}<span v-if="props.item.sbware.length > 0 && index !== (props.item.sbware.length - 1)">, </span>
                </span>
              </td>
              <td class="text-xs-left" @click="openList(props.item)">
                <span v-for="(date, index) in props.item.theke" :key="index">
                  {{ date | formatDateShort }}<span v-if="props.item.theke.length > 0 && index !== (props.item.theke.length - 1)">, </span>
                </span>
              </td>
                
            </template>
            <template v-slot:no-data>
                <v-alert :value="true" color="error" icon="warning" class="tableColor">
                  Keine Daten gefunden!
              </v-alert>
            </template>
        </v-data-table>
      </div>
      <div class="card" v-if="this.checkbox && !loading">
        <div class="card--center">
          <label class="labelVerk">Verkaufte Produkte:</label>
        </div>
        <div class="table-responsive">
          <v-data-table
            :headers="headers"
            :items="filteredListsSold"
            class="elevation-1"
            :pagination.sync="paginationBottom">
              <template v-slot:items="props">
                  
                  <td class="text-xs-left" @click="openList(props.item)">{{ props.item.lieferscheindatum | formatDate }}</td>
                  <td class="text-xs-left" @click="openList(props.item)">{{ props.item.herkunft.value }}: {{ props.item.herkunft.name }}</td>
                  <td class="text-xs-left" @click="openList(props.item)">{{ props.item.product }}</td>
                  <!-- <td class="text-xs-left" @click="openList(props.item)">{{ props.item.sbware.name }}</td> -->
                  <td class="text-xs-left" @click="openList(props.item)">
                    <span v-for="(kategorie, index) of props.item.sbware" :key="kategorie.value">
                      {{ kategorie.name }}<span v-if="props.item.sbware.length > 0 && index !== (props.item.sbware.length - 1)">, </span>
                    </span>
                  </td>
                  <td class="text-xs-left" @click="openList(props.item)">
                    <span v-for="(date, index) in props.item.theke" :key="index">
                      {{ date | formatDateShort }}<span v-if="props.item.theke.length > 0 && index !== (props.item.theke.length - 1)">, </span>
                    </span>
                  </td>
                  
              </template>
              <template v-slot:no-data>
                  <v-alert :value="true" color="error" icon="warning" class="tableColor">
                    Keine Daten gefunden!
                </v-alert>
              </template>
          </v-data-table>
        </div>
      </div>
    </div>



    <div v-if="this.dialog">
      <v-layout row justify-center>
        <v-dialog v-model="dialog" fullscreen hide-overlay>
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>OrgaInvent</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-progress-linear v-if="loadingDialog" color="red" :indeterminate="true"></v-progress-linear>
            <card id="frame" v-if="!isLoading && !loadingDialog">
              <div>
                <table style="width:100%; font-size: 16px">
                  <colgroup>
                    <col span="1" style="width: 200px;">
                    <col span="1">
                  </colgroup>
                  <tr>
                    <td>Lieferscheindatum:</td>
                    <td>{{ listItem.lieferscheindatum | formatDate }}</td>
                  </tr>
                  <tr>
                    <td>Ihr Name:</td>
                    <td>{{ listItem.name }}</td>
                  </tr>
                  <tr>
                    <td>Lieferant:</td>
                    <td>{{ listItem.lieferant.name }}</td>
                  </tr>
                  <tr>
                    <td>Herkunft:</td>
                    <td>{{ listItem.herkunft.name }}</td>
                  </tr>
                </table>
                <br>
                <p>Kennzeichnungsangaben:</p>
                <v-container v-if="listItem.image === null || listItem.image === ''" style="padding: 0; margin: 0;">
                  <table style="width:100%; font-size: 16px">
                    <colgroup>
                      <col span="1" style="width: 200px;">
                      <col span="1">
                    </colgroup>
                    <tr>
                      <td>Produkt / Artikel:</td>
                      <td>{{ listItem.product }}</td>
                    </tr>
                    <tr>
                      <td>Ident.-Nr.:</td>
                      <td>{{ listItem.identNummer }}</td>
                    </tr>
                    <tr>
                      <td>Schlachtbetrieb:</td>
                      <td>{{ listItem.slaughter }}</td>
                    </tr>
                    <tr>
                      <td>Zerlegungsbetrieb:</td>
                      <td>{{ listItem.cutting }}</td>
                    </tr>
                    <tr>
                      <td>SB-Ware / Verwendung:</td>
                      <!-- <td>{{ listItem.sbware.name }}</td> -->
                      <td>
                        <span v-for="(kategorie, index) of listItem.sbware" :key="kategorie.value">
                          {{ kategorie.name }}<span v-if="listItem.sbware.length > 0 && index !== (listItem.sbware.length - 1)">,</span>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>In die Theke gelegt:</td>
                      <td>
                        <span v-for="(date, index) in listItem.theke" :key="index">
                          {{ date | formatDateShort }}<span v-if="index !== (listItem.theke.length - 1) && listItem.theke.length > 0">, </span>
                        </span>
                      </td>
                    </tr>
                  </table> 
                </v-container>
                <v-container v-else  style="padding: 0; margin: 0;">
                  <table style="width:100%; font-size: 16px">
                    <colgroup>
                      <col span="1" style="width: 200px;">
                      <col span="1">
                    </colgroup>
                    <tr>
                      <td>Produkt / Artikel:</td>
                      <td>{{ listItem.product }}</td>
                    </tr>
                    <tr>
                      <td>SB-Ware / Verwendung:</td>
                      <!-- <td>{{ listItem.sbware.name }}</td> -->
                      <td>
                        <span v-for="(kategorie, index) of listItem.sbware" :key="kategorie.value">
                          {{ kategorie.name }}<span v-if="listItem.sbware.length > 0 && index !== (listItem.sbware.length - 1)">,</span>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>In die Theke gelegt:</td>
                      <td>
                        <span v-for="(date, index) in listItem.theke" :key="index">
                          {{ date | formatDateShort }}<span v-if="index !== (listItem.theke.length - 1) && listItem.theke.length > 0">, </span>
                        </span>
                      </td>
                    </tr>
                  </table>
                  <br>
                  <div>
                    <img :src="listItem.image"/>
                  </div>
                </v-container>
              </div>
            </card>
            <div v-if="isLoading">
              <div class="alert alert-warning" v-if="showLoadingMessage && tick === 3" id="alert">
                <!-- Loading -->
                <button type="button" aria-hidden="true" class="close"></button>
                <center>
                  <span>Eintrag wird erstellt, bitte warten</span>
                  <br>
                  <v-progress-circular :size="30" :width="7" color="red" indeterminate></v-progress-circular>
                </center>
              </div>
              <div class="alert alert-success" v-if="showSuccessMessage && tick === 3" id="alert">
                <!-- Erfoglsmeldung -->
                <button type="button" aria-hidden="true" class="close"></button>
                <span>
                <b>Erfolgreich erstellt! - </b> Ein entsprechender Eintrag wurde vorgenommen!</span>
              </div>
              <div class="alert alert-danger" v-if="showOnlineMessage && tick === 3 && $online">
                <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
                <span>
                  <b>Upload dauert länger. ({{ counterFront }} Sekunden)</b>
                </span>
                <!-- <button v-if="counterFront === 10" class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button> -->
              </div>
              <div class="alert alert-danger" v-if="showOnlineMessage && tick === 3 && !$online">
                <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
                <span>
                  <b>Stellen Sie eine Internetverbindung her. ({{ counterFront }} Sekunden)</b>
                </span>
                <!-- <button v-if="counterFront === 10" class="btn btn-lg btn-danger float-left" v-on:click="cancel()" type="button">abbrechen</button> -->
              </div>
              <div class="alert alert-danger" v-if="showErrorMessage && tick === 4">
                <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
                <span>
                  <b>Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut</b>
                </span>
              </div>
            </div>
            <v-divider />
            <div v-if="tick === 1 && !listItem.sold && !isLoading && !loadingDialog">
              <div class="alert alert-warning" v-if="!$online">
                <span>
                  <center>
                      <v-icon size="25">error</v-icon>
                      <b>Bitte stellen Sie eine Internetverbindung her!</b>
                      <v-icon size="25">error</v-icon>
                  </center>
                </span>
              </div>
              <card :title="'Tag hinzufügen/entfernen?'" id="frame" class="card--center">
                <div v-if="tmpTheke" class="center">
                  <v-date-picker
                    locale="de"
                    color="green lighten-1" header-color="#212121"
                    v-model="datesTheke"
                    multiple
                  ></v-date-picker>
                </div>
                <button v-if="!tmpTheke" class="btn btn-warning" v-on:click="tmpTheke = !tmpTheke" type="button">bestätigen</button>
                <button v-if="tmpTheke" class="btn btn-danger" v-on:click="tmpTheke = !tmpTheke" type="button">abbrechen</button>
                <button v-if="tmpTheke" class="btn btn-success" v-on:click="save(0, listItem)" type="button" style="margin-left: 10px">bestätigen</button>
              </card>
              <card :title="listItem.product + ' ausverkauft?'" id="frame" class="card--center"  style="z-index: 8">
                <button v-if="!tmpSold" class="btn btn-warning" v-on:click="tmpSold = !tmpSold" type="button">bestätigen</button>
                <button v-if="tmpSold" class="btn btn-danger" v-on:click="tmpSold = !tmpSold" type="button">abbrechen</button>
                <button v-if="tmpSold" class="btn btn-success" v-on:click="save(1, listItem)" type="button" style="margin-left: 10px">bestätigen</button>
                <br>
                <br>
                <button class="btn btn-lg btn-danger float-left" v-on:click="cancel(0)" type="button">zurück</button>
              </card>
            </div>
            <div v-if="this.tick === 1 && listItem.sold && !isLoading">
              <card :title="'Artikel verkauft!'" id="frame" class="card--center">
                <button class="btn btn-lg btn-danger float-left" v-on:click="cancel(0)" type="button">zurück</button>
              </card>
            </div>
          </v-card>
        </v-dialog>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import { helpers } from "vuelidate/lib/validators"
import navigation from "../../../../store/navigation"

export const alphaDiacritic = helpers.regex("alphaDiacritic", /^[a-zA-ZÀ-ž ]*$/)

export default {
    mixins: [validationMixin],

    validations: {
        tmpName: { required, alphaDiacritic },
        tmpTemperatur: { required }
    },
    data() {
        return {
            auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
            dialog: false,
            changeStatusDialog: true,
            startup: 1,
            upload: false,
            uploadAnzahl: 0,
            uploadZaehler: 0,
            showAlarm: false,
            showSuccess: false,
            title: "OrgaInvent",
            routeBack: [],
            itemsPerPage: 15,
            rowsPerPageItems: [10, 20, 30, 40],
            pagination: {
                rowsPerPage: 20
            },
            paginationBottom: {
                rowsPerPage: 20
            },

            tick: 1,

            // Dialog:
            listItem: {},
            tmpSold: false,
            datesTheke: [],
            tmpTheke: false,
            isLoading: false,
            loadingDialog: false,

            // Startup:
            startdate: "",
            enddate: "",
            showAlarm: false,
            showSuccess: false,
            showErrorMessage: false,
            showSuccessMessage: false,
            showOnlineMessage: false,
            showLoadingMessage: false,

            counterFront: 0,

            // orgainvent Table
            lists: [],
            filteredLists: [],
            filteredListsSold: [],
            headers: [
                {
                    text: "Lieferscheindatum",
                    align: "left",
                    sortable: false,
                    value: "lieferscheindatum"
                },
                {
                    text: "Herkunft",
                    align: "left",
                    sortable: false,
                    value: "herkunft"
                },
                {
                    text: "Kennzeichnungsangaben",
                    align: "left",
                    sortable: false,
                    value: "product"
                },
                {
                    text: "SB-Ware",
                    align: "left",
                    sortable: false,
                    value: "sbware"
                },
                {
                    text: "Theke",
                    align: "left",
                    sortable: false,
                    value: "theke"
                }
            ],
            selectedSBWare: { value: 0, name: "" },
            sbWare: [{ value: 0, name: "---" }, { value: 1, name: "Steak" }, { value: 2, name: "Sonstiges" }],
            selectedProduct: "",
            products: [],
            filteredProducts: [],
            checkbox: false,
            checkboxLabel: "anzeigen",
            loading: false
        }
    },
    methods: {
        disableNotification() {
            this.showAlarm = false
            this.showSuccess = false
            this.uploadZaehler = 0
            this.uploadAnzahl = 0
        },
        download() {
            this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/qs/json2xls", { data: this.lists, area: this.title }).then(function(response) {
                window.location = process.env.VUE_APP_NODE_API_URL + response.body
            })
        },
        save(check, list) {
            // 0 = Tag hinzufuegen
            var counter = 0
            this.datesTheke.map((erg) => {
                list.theke.includes(erg) ? "" : (counter += 1)
            })
            var bool = counter > 0 || list.theke.length !== this.datesTheke.length

            if (check === 0 && bool) {
                this.isLoading = true
                list.sold ? (list.sold = 1) : (list.sold = 0)
                var tempList = list
                tempList.theke = JSON.stringify(this.datesTheke)
                this.updateList(tempList, 0)
            } else if (check === 1) {
                this.isLoading = true
                list.sold = 1
                var tempList = list
                tempList.theke = JSON.stringify(tempList.theke)
                this.updateList(tempList, 0)
            }
        },
        updateList(list, check) {
            this.tick = 3
            this.showLoadingMessage = true
            let counter = 0
            let internetCounter = 0
            var interval = setInterval(() => {
                if (this.$online && internetCounter === 0) {
                    internetCounter = 1
                    this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/qs/orgainvent/liste/update", list, { headers: { Authorization: this.auth } }).then(function(response) {
                        if (response.body.error) {
                            console.log(response.body.error)
                            this.tick = 4
                            this.showLoadingMessage = false
                            this.showErrorMessage = true
                            this.counterFront = 0
                            clearInterval(interval)
                            setTimeout(() => this.cancel(check), 1500)
                        } else {
                            this.showLoadingMessage = false
                            this.showOnlineMessage = false
                            this.showSuccessMessage = true
                            this.counterFront = 0
                            clearInterval(interval)
                            setTimeout(() => this.cancel(check), 1500)
                        }
                    })
                } else {
                    this.counterFront++
                    if (counter === 3) {
                        this.showOnlineMessage = true
                    }
                }
                counter++
                if (counter === 10) {
                    clearInterval(interval)
                }
            }, 1000)
        },
        cancel(check) {
            if (check === 0) {
                this.tick = 1
                this.dialog = false
                this.tmpSold = false
                this.listItem = {}
                this.datesTheke = []
                this.tmpTheke = false
                this.tmpThekeLoeschen = false
                this.isLoading = false
                this.showSuccessMessage = false
                this.loadLists(this.startdate, this.enddate)
            } else if (check === 1) {
                this.tick = 1
                // this.loadLists(this.startdate, this.enddate);
                this.getList(this.listItem.id)
                this.datesTheke = []
                this.tmpTheke = false
                this.tmpSold = false
                this.tmpThekeLoeschen = false
            }
        },
        getList(id) {
            this.$http
                .get(process.env.VUE_APP_NODE_API_URL + "/heimspiel/qs/orgainvent/list/" + id, { headers: { Authorization: this.auth } })
                .then(function(response) {
                    this.listItem = {}
                    this.listItem = response.body.data[0]
                    this.listItem.sbware = this.checkSbware(response.body.data[0])
                    this.listItem.herkunft = this.checkHerkunft(response.body.data[0])
                    this.listItem.lieferant = this.checkLieferant(response.body.data[0])
                    this.listItem.theke = JSON.parse(response.body.data[0].theke)
                    this.listItem.sold === 0 ? (this.listItem.sold = false) : (this.listItem.sold = true)
                    this.isLoading = false
                    this.showSuccessMessage = false
                })
                .catch((e) => {
                    e.body === "" ? (this.lists = this.lists) : ""
                    this.cancel(0)
                })
        },
        openList(item) {
            this.loadingDialog = true
            this.dialog = true
            this.$http
                .get(process.env.VUE_APP_NODE_API_URL + "/heimspiel/qs/orgainvent/list/" + item.id, { headers: { Authorization: this.auth } })
                .then(function(response) {
                    console.log(response.body.data)
                    this.listItem = item
                    this.listItem.image = response.body.data[0].image
                    this.datesTheke = item.theke
                    this.loadingDialog = false
                })
                .catch((e) => {
                    console.log(e)
                    e.body === "" ? (this.lists = this.lists) : ""
                    this.cancel(0)
                })
        },
        goBack(route) {
            if (route !== "orgainvent") {
                this.$router.push({ path: navigation.createNav(route).path })
            }
        },
        changeCheckbox() {
            !this.checkbox ? (this.checkboxLabel = "anzeigen") : (this.checkboxLabel = "ausblenden")
            this.filterLists()
        },
        filterLists() {
            this.filteredLists = this.lists.filter((i) => {
                if (this.selectedSBWare.value === 0) {
                    return !i.sold
                } else if (this.selectedSBWare.value === 1) {
                    return i.sbware.filter((sb) => [4].includes(sb.value)).length > 0 && !i.sold
                } else if (this.selectedSBWare.value === 2) {
                    return i.sbware.filter((sb) => [1, 2, 3, 5].includes(sb.value)).length > 0 && !i.sold
                }
            })
            this.filteredLists = this.filteredLists.filter((i) => {
                if (this.selectedProduct === "---" || this.selectedProduct === "") {
                    return i.sold === false || i.sold === this.checkbox
                } else {
                    return this.selectedProduct === i.product && (i.sold === false || i.sold === this.checkbox)
                }
            })
            this.filteredListsSold = this.lists.filter((i) => {
                if (this.selectedSBWare.value === 0) {
                    return i.sold
                } else if (this.selectedSBWare.value === 1) {
                    return i.sbware.filter((sb) => [4].includes(sb.value)).length > 0 && i.sold
                } else if (this.selectedSBWare.value === 2) {
                    return i.sbware.filter((sb) => [1, 2, 3, 5].includes(sb.value)).length > 0 && i.sold
                }
            })
            this.filteredListsSold = this.filteredListsSold.filter((i) => {
                if (this.selectedProduct === "---" || this.selectedProduct === "") {
                    return i.sold
                } else {
                    return this.selectedProduct === i.product && i.sold
                }
            })
        },
        addOrgainvent() {
            this.$router.push({ path: "orgainvent/add" })
        },
        startupFetch() {
            var today = new Date()
            today.setDate(today.getDate() - 14)
            var dd = String(today.getDate()).padStart(2, "0")
            var mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
            var yyyy = today.getFullYear()

            var startdate = yyyy + "-" + mm + "-" + dd
            this.startdate = startdate

            var weekAgo = new Date()
            var dd1 = String(weekAgo.getDate()).padStart(2, "0")
            var mm1 = String(weekAgo.getMonth() + 1).padStart(2, "0") //January is 0!
            var yyyy1 = weekAgo.getFullYear()
            var enddate = yyyy1 + "-" + mm1 + "-" + dd1
            this.enddate = enddate
            this.loadLists(this.startdate, this.enddate)
        },
        loadLists(startdate, enddate) {
            if (startdate && enddate && startdate <= enddate) {
                this.startdate = startdate
                this.enddate = enddate
            }
            this.fetchData(this.startdate, this.enddate)
        },
        fetchData(start, end) {
            this.loading = true
            if (start <= end) {
                console.log("Abrufen der Logs aus der DB")
                try {
                    this.$http
                        .get(process.env.VUE_APP_NODE_API_URL + "/heimspiel/qs/orgainvent/" + start + "&" + end, { headers: { Authorization: this.auth } })
                        .then(function(response) {
                            // wenn nicht der StartupFetch, dann vorher Logs löschen
                            if (this.startup === 0) {
                                this.lists = []
                            }
                            const dbLists = response.body.data
                            this.pagination.totalItems = response.body.length
                            this.pagination.itemsPerPage = 15
                            if (dbLists.length > 0) {
                                dbLists.map((liste) => {
                                    liste.synchronized = true
                                    liste.sbware = this.checkSbware(liste)
                                    liste.herkunft = this.checkHerkunft(liste)
                                    liste.lieferant = this.checkLieferant(liste)
                                    liste.theke = JSON.parse(liste.theke)
                                    liste.sold === 0 ? (liste.sold = false) : (liste.sold = true)
                                    this.products.length === 0 ? this.products.push("---") : ""
                                    this.products.includes(liste.product) && liste.sold ? "" : this.products.push(liste.product)
                                    this.lists.push(liste)
                                })
                            }
                            this.filterLists()
                            // startup = 0 damit die Logs geleert werden wenn neue abgerufen werden
                            this.loading = false
                            this.startup = 0
                            console.log(this.lists)
                        })
                        .catch((e) => {
                            e.body === "" ? (this.lists = this.lists) : ""
                        })
                } catch (e) {
                    console.log(e)
                }
            }
        },
        checkSbware(liste) {
            liste.sbware = JSON.parse(liste.sbware).map((kat) => {
                if (kat === 1) {
                    return (kat = { value: 1, name: "Braten/Gulasch" })
                } else if (kat === 2) {
                    return (kat = { value: 2, name: "Rouladen" })
                } else if (kat === 3) {
                    return (kat = { value: 3, name: "Suppenfleisch" })
                } else if (kat === 4) {
                    return (kat = { value: 4, name: "Steak" })
                } else if (kat === 5) {
                    return (kat = { value: 5, name: "Hackfleisch" })
                }
            })
            return liste.sbware
        },
        checkLieferant(liste) {
            switch (liste.lieferant) {
                case 1:
                    liste.lieferant = { value: 1, name: "REWE" }
                    break
                case 2:
                    liste.lieferant = { value: 2, name: "Nagel" }
                    break
                case 3:
                    liste.lieferant = { value: 3, name: "Vita Beef" }
                    break
                case 4:
                    liste.lieferant = { value: 4, name: "Niegemann" }
                    break
            }
            return liste.lieferant
        },
        checkHerkunft(liste) {
            switch (liste.herkunft) {
                case 1:
                    liste.herkunft = { value: 1, name: "Herkunft, Zerlegung Herstellung: Deutschland" }
                    break
                case 2:
                    liste.herkunft = { value: 2, name: "Argenada = Herkunft, Zerlegung: Argentinien" }
                    break
                case 3:
                    liste.herkunft = { value: 3, name: "Färsenfleisch bayrischer Wald = Herkunft, Zerlegung: bayrischer Wald (Deutschland)" }
                    break
                case 4:
                    liste.herkunft = { value: 4, name: "Irish Beef = Herkunft, Zerlegung: Irland" }
                    break
                case 5:
                    liste.herkunft = { value: 5, name: "Wagyu Beef = Herkunft, Zerlegung: Neuseeland" }
                    break
                case 6:
                    liste.herkunft = { value: 6, name: "Charolals Rind = Herkunft, Zerlegung: Frankreich" }
                    break
                case 7:
                    liste.herkunft = { value: 7, name: "US Beef Variante I = Herkunft, Zerlegung: USA" }
                    break
                case 8:
                    liste.herkunft = { value: 8, name: "US Beef Variante II = Herkunft, Zerlegung: USA und Deutschland" }
                    break
                case 9:
                    liste.herkunft = { value: 9, name: "Bison Variante I = Herkunft, Zerlegung: Kanada" }
                    break
                case 10:
                    liste.herkunft = { value: 10, name: "Bison Variante II = Geburt und Mast: Kanada; Schlachtung und Zerlegung: USA" }
                    break
            }
            return liste.herkunft
        }
    },
    computed: {
        // dateThekeErrors () {
        //   const errors = [];
        //   if (this.dateTheke === '') {
        //     errors.push('Bitte geben Sie ein Datum ein');
        //   } else if (this.dateTheke !== '' && this.listItem.theke.includes(this.dateTheke)) {
        //     errors.push('Datum bereits vorhanden');
        //   }
        //   return errors;
        // },
    },
    created: function() {
        this.routeBack = navigation.createNav("orgainvent").params
        this.startupFetch()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#frame {
    margin-left: 0%;
    margin-top: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;
}

.card--center {
    text-align: center;
}

#date {
    margin-bottom: 10px;
    padding: 5px;
    border: 2px solid rgb(117, 108, 108);
    border-radius: 5px;
}

.auswahl {
    padding: 3px 3px 10px 3px !important;
}

.backBar:hover {
    cursor: pointer;
    text-decoration: underline;
    color: red;
}

.pointer {
    cursor: default;
}

.tableBorder {
    border-top: unset;
}

.angaben {
    font-size: large;
    font-weight: bold;
}

v-row {
    padding-left: 10px;
    padding-right: 20px;
}

.tableColor {
    color: black;
}

.center {
    margin: auto;
    width: 250px;
    padding: 10px;
}

.labelVerk {
    margin: 10px;
}

img {
    width: 45%;
    margin: auto;
    display: block;
    margin-bottom: 10px;
}
</style>
